<div class="actionwrapper">
    <div class="actions">
        <button mat-raised-button color="primary" (click)="addItem()">
            <mat-icon>add</mat-icon>
            Add new branding config
        </button>
    </div>
</div>
<table class="table" mat-table matSort [dataSource]="items">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.name}}</td>
  </ng-container>
  <ng-container matColumnDef="colors">
    <th mat-header-cell *matHeaderCellDef>Colors (primary/secondary)</th>
    <td class="cell" mat-cell *matCellDef="let item">
      <div class="brandColorsContainer">
        <div class="brandColor" style="background-color: {{item.ourlyPrimaryColor}}"></div>
        <div class="brandColor" style="background-color: {{item.ourlySecondaryColor}}"></div>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="url">
    <th mat-header-cell *matHeaderCellDef>URL</th>
    <td class="cell" mat-cell *matCellDef="let item">
      <a href="https://{{item.redirectUrl}}" rel="external noopener noreferrer" target="_blank">
        {{item.redirectUrl}}
      </a>
    </td>
  </ng-container>
  <ng-container matColumnDef="logo">
    <th mat-header-cell *matHeaderCellDef >Logo</th>
    <td class="cell" mat-cell *matCellDef="let item">
      <img alt="{{item.name}} logo" class="brandLogo" *ngIf="item.logoUrl" src="{{item.logoUrl}}"/>
    </td>
  </ng-container>
    <ng-container matColumnDef="actionmenu" stickyEnd>
      <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item"><button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button></td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent let-item="item">
        <button mat-menu-item (click)="editItem(item)">Edit</button>
        <button mat-menu-item (click)="clickMenuItem(item)">Duplicate</button>
        <button mat-menu-item (click)="clickMenuItem(item)">Remove</button>
      </ng-template>
    </mat-menu>
</table>
